import { format, parseISO } from 'date-fns'
import { enUS } from 'date-fns/locale'

export const formatDate = (date: Date) =>
  `${format(parseISO(date.toString()), 'PP', {
    locale: enUS,
  })} ${format(parseISO(date.toString()), 'p', { locale: enUS })}`
